// @ts-ignore
import {Modal} from "./Modal.tsx";
// @ts-ignore
import ParticipantsStatus from "./elements/ParticipantsStatus.tsx";
import FieldWeex from "./elements/FieldWeex";
import {useContext, useState} from "react";
// @ts-ignore
import {APIContext} from "./Globals.tsx";
import {PersonDTO} from "./model/PersonDTO";
import {sexes} from './ToDos.js'
import SelectWeex from "./elements/SelectWeex";
import TextInputWeex from "./elements/TextInputWeex";

function renderComponent(comp){
  return <div className={"component_wrapper"}>
    <h4>{comp.name}</h4>
    {comp.description}
  </div>;
}

export function CourseModal({onClose, course, users, locations, setCourse}){
  const [addUserModal, setAddUserModal] = useState(false)
  const randomNumber = Math.round(Math.random()*1000); // Generates a random number between 0 and 1
  const [newPerson, setNewPerson] = useState<PersonDTO>({
    firstname: "",
    lastname: "",
    email: "guest" + randomNumber + "@weexplan.com",
    sex: "",
    birthday: "2000-01-10",
    tickets: parseInt("1"),
    ticketsMax: parseInt("1"),
    contract:{
      repeat: "block_1",
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    }
  })
  const [addGuest, setAddGuest] = useState(false)
  const [searchUser, setSearchUser] = useState("")
  const {signInPerson, signOutPerson, addUser} = useContext(APIContext)

  function addGuestAndSignIn(){
    addUser(newPerson).then((user) => {
      if(user){
        setAddGuest(false)
        signInPerson(course.id, user.id).then((course) => {
          setCourse(course)
          window.location.reload()
        })
      }
    })
  }

  function renderPerson(per, i?){
    if(!per)
      return null
    return <div
      className={"list_element"}
      style={{
        backgroundColor: !i || i % 2 == 0 ? "var(--darkgray)" : "var(--background)", cursor: "pointer"
      }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#5583ca"}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = (!i || i % 2 == 0) ? "var(--darkgray)" : "var(--background)"}
      onClick={() => {
        if(!isNaN(i)){
          if(per.firstname === "Gast") setAddGuest(true); else signInPerson(course.id, per.id).then((course) => {
            if(course) setCourse(course)
          })
        } else {
          signOutPerson(course.id, per.id).then((course) => {
            setCourse(course)
          })
        }
      }}
    >
      {per.firstname + " " + (per.lastname ?? "")}
    </div>;
  }

  if(!course || !users || !locations)
    return (<Modal actionP={()=>{}} actionS={()=>{}}>
      Daten werden geladen...
    </Modal>)

  return <Modal actionP={onClose} buttonP={"Schließen"} actionS={() => {
  }} valid={true}>
    {addGuest && <Modal actionP={addGuestAndSignIn} actionS={() => {
      setAddGuest(false)
    }} buttonP={"Speichern"} buttonS={"Abbrechen"} valid={true}>
        <div>
            <h3>Neuen Teilnehmer hinzufügen</h3>
            <div style={{display: "grid", gap: "1rem"}}>
                <div>
                    <label htmlFor="firstname">Vorname: </label>
                    <input
                        id="firstname"
                        type="text"
                        value={newPerson.firstname || ""}
                        onChange={(e) => setNewPerson({...newPerson, firstname: e.target.value})}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="lastname">Nachname: </label>
                    <input
                        id="lastname"
                        type="text"
                        value={newPerson.lastname || ""}
                        onChange={(e) => setNewPerson({...newPerson, lastname: e.target.value})}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="sex">Geschlecht: </label>
                    <SelectWeex options={sexes}
                                onChange={(e) => setNewPerson({...newPerson, sex: e.value})}
                                placeholder={"M/W/D"}
                                isMulti={false}
                                valueRaw={newPerson.sex}
                                isClearable={false}
                                style={{width: 110, display: "inline-block"}}
                    />
                </div>
                <div id={"error-message"}></div>
            </div>
        </div>
    </Modal>}
    <div className={"grid course-modal"}>
      <div>
        <div className={"grid course-meta"}>
          <FieldWeex label={"Kurs"}>{course.type}</FieldWeex>
          <FieldWeex label={"Datum"}>{course.startDate}</FieldWeex>
          <FieldWeex
            label={"Uhrzeit"}>{course.startTime + " - " + course.endTime + " Uhr"}</FieldWeex>
          <FieldWeex
            label={"Trainer"}>{users.find(person => person.id === course.coach)?.firstname}</FieldWeex>
          <FieldWeex
            label={"Ort"}>{locations.find(loc => loc.id === course.location)?.name}</FieldWeex>
        </div>
        <div>
          {course.components.map(renderComponent)}
        </div>
      </div>
      <div style={{textAlign: "left"}}>
        <ParticipantsStatus item={course} style={{marginBottom: 80}}/>
        Teilnehmer:
        <div className={"participants-list"}>
          {course.participants.map(per => <div>{renderPerson(users.find(person => person.id === per))}</div>)}
        </div>
        <a style={{color: "var(--accent)", cursor: "pointer"}} onClick={() => setAddUserModal(true)}>+ Teilnehmer hinzufügen</a>
        {addUserModal && <div style={{
          borderStyle: "solid",
          borderColor: "var(--white)",
          borderWidth: 1,
          borderRadius: 10,
          overflowY: "scroll",
          maxHeight: "calc(90vh - 230px)",
          maxWidth: "90%"
        }}>
          {/*{users.filter().map((person, i) => renderPerson(person, i))}*/}
          <TextInputWeex onChange={(e)=>setSearchUser(e.target.value)} placeholder={"Suchen..."} value={searchUser} />
          {[{firstname: "Gast"}, ...users.filter(person => !course.participants.includes(person.id)).filter(person => (person.firstname+person.lastname).toLowerCase().includes(searchUser.toLowerCase()))].map((person, i) => renderPerson(person, i))}
        </div>}
      </div>
    </div>
  </Modal>;

}
